export const Pipeline = {
    props: {
        task: {
          type: Object,
          default: () => ({}),
        },
        search: String,
        shown: Boolean,
        shipmentCount: Array,
        max_shipment_article_items: String,
        defaultArticleImage: String,
        teamName: String,
    },
     data() {
        return {
        modalData: null,
        itemid: "",
        selectedBike: null,
        shipableItem: 1,
        item:"",
        salesType:"normal",
        selectedBikes: []
        };
    },
    methods: {
        toggleOrderModal(task, itemid,item,type) {
          this.modalData = task;
          this.itemid = itemid;
          this.item=item;
          this.salesType=type;
          this.orderModalShown = !this.orderModalShown;
        },
        toggleShipmentModal(task, item,type) {
          this.modalData = task;
          this.itemid = item;
          this.salesType=type;
          this.shipmentModalShown = !this.shipmentModalShown;
        },
        toLowerArticleNumber(item) {
          let searchList = this.search
            .toLowerCase()
            .split(/(\s+)/)
            .filter(function (e) {
              return e.trim().length > 0;
            });
          if (
            item.articleNumber &&
            searchList.some((v) => item.articleNumber.toLowerCase().includes(v))
          ) {
            return true;
          } else return false;
        },
        toLowerTitle(item) {
          let searchList = this.search
            .toLowerCase()
            .split(/(\s+)/)
            .filter(function (e) {
              return e.trim().length > 0;
            });
          if (
            item.title !== undefined &&
            searchList.some((v) => item.title.toLowerCase().includes(v))
          ) {
            return true;
          } else {
            return false;
          }
        },
        toLowerTask(task) {
          let searchList = this.search
            .toLowerCase()
            .split(/(\s+)/)
            .filter(function (e) {
              return e.trim().length > 0;
            });
          if (
            task.orderNumber &&
            searchList.some((v) => task.orderNumber.toLowerCase().includes(v))
          ) {
            return true;
          } else if (
            task.salesOrderNumber &&
            searchList.some((v) => task.salesOrderNumber.toLowerCase().includes(v))
          ) {
            return true;
          } else return false;
        },
        checkDate(value) {
          const TodayDate = this.formatDate(new Date());
          let ItemDate = this.formatDate(value);
          return ItemDate.includes(TodayDate);
        },
        decreasequantity(item, taskId ,taskOrderNumber) {
          const index = this.selectedBikes.findIndex(bike => 
            bike.articleId === item.articleId 
            && bike.orderId === taskId 
            &&  bike.orderItemId === item.id 
            &&  bike.salesOrderNumber === taskOrderNumber);

          if (index !== -1) {
            if (this.selectedBikes[index].shipableItem > 1) {
              this.selectedBikes[index].shipableItem -=1;
              const itemToUpdate =  this.selectedBikes[index];
              this.$emit("updateBike", { itemToUpdate});
            }
          }
        },
        incrementquantity(item, taskId,taskOrderNumber) {
          const index = this.selectedBikes.findIndex(bike => 
            bike.articleId === item.articleId 
            && bike.orderId === taskId 
            &&  bike.orderItemId === item.id && 
            bike.salesOrderNumber === taskOrderNumber);
         
          if (index !== -1) {
            let Quantity = this.calculateQuantity(item);
            let Threshold = parseInt(this.max_shipment_article_items);
            let maximum = 0;
            
            if (Number.isNaN(Threshold) || Quantity < Threshold) {
              maximum = Quantity;
            } else {
              maximum = Threshold;
            }

            if ( this.selectedBikes[index].shipableItem < maximum) {
              this.selectedBikes[index].shipableItem += 1;
              const itemToUpdate =  this.selectedBikes[index];
              this.$emit("updateBike", { itemToUpdate});
            }
          }
        },
        passEvent(orderItemId,articleId,articleName,taskId, taskOrderNumber,isSelected)
        {
          if(isSelected){
            const newItem = {'orderItemId':orderItemId,'orderId':taskId, 'articleId': articleId, 'articleName':articleName, 'shipableItem': 1, 'salesOrderNumber': taskOrderNumber};
            this.selectedBikes.push(newItem);
            
            let data = {
              orderId: taskId,
              orderItemId:orderItemId,
              articleId: articleId,
              articleName:articleName,
              shipableItems:1,
              salesOrderNumber: taskOrderNumber,
            };
            const isAddingItem = true;
            this.$emit("sendBike", {data,isAddingItem});
          }
          else{
            const index = this.selectedBikes.findIndex(
              (item) => item.articleId === articleId && item.orderId === taskId &&  item.orderItemId === orderItemId && item.salesOrderNumber === taskOrderNumber
            );
            
            if (index > -1) {
              const data = this.selectedBikes[index];
              const isAddingItem = false;
              this.$emit("sendBike", {data,isAddingItem});
              this.selectedBikes.splice(index, 1);
            }
          }
        },
        searchValue(value) {
          this.$emit("sendSearch", value);
        },
        checkItem(ordernumber) {
          let count = 0;
          this.shipmentCount.forEach((element) => {
            if (element["key"] === ordernumber) {
              count = element["count"];
            }
          });
          return count;
        },
        calculateQuantity(item) {
          if (item.requested_qty) {
            return (
              Number(item.quantity) -
              (Number(item.requested_qty) + Number(item.shippedQuantity))
            );
          } else {
            return Number(item.quantity) - Number(item.shippedQuantity);
          }
        },
        checkIfSalesBillOfMaterial(task,itemTask){
          let items='';
          if ( task[itemTask].length == undefined) {
            items = Object.values( task[itemTask]);
          } else items =  task[itemTask];
          const keyToCheck = 'parentItemId';
          const hasKey = items.some(item => item.hasOwnProperty(keyToCheck));
          return hasKey;
        },
        isSelected(item) {
          return this.selectedBikes.some(selectedItem => selectedItem.itemId === item.itemId && selectedItem.parentId === item.parentId && selectedItem.shipableItem === item.shipableItem);
        }
    },
    computed: {
        badgeColor() {
          const mappings = {
            CLOSED: "bg-red-200",
            CANCELLED: "bg-red-200",
            ORDER_ENTRY_IN_PROGRESS: "bg-blue-200",
            ORDER_CONFIRMATION_PRINTED: "bg-green-200",
            NEW: "bg-blue-200",
            SHIPPED: "bg-green-200",
            DELIVERY_NOTE_PRINTED: "bg-yellow-200",
            default: "bg-green-200",
          };
          return mappings[this.task.status] || mappings.default;
        },
    },
};